import { FC, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import UserImage4 from "../../../assets/img/wanna/wanna5.png";
import axios from "../../../common/axios";
import Avatar from "../../../components/Avatar";
import Button from "../../../components/bootstrap/Button";
import Modal, {
  ModalBody,
  ModalHeader
} from "../../../components/bootstrap/Modal";
import Icon from "../../../components/icon/Icon";
import Loading from "../../../components/Loading";
import AuthContext, { IAuthContextProps } from "../../../contexts/authContext";
import Header, { HeaderLeft, HeaderRight } from "../../../layout/Header/Header";
import iot from "../../../routes/contentRoutes";

type TBalance = {
  balances?: number; // 599003,
  agency?: string; // "Itel",
  name?: string; // "Nguyen van D"
};
const BalancesHeader: FC = () => {
  const [avatar, setAvatar] = useState<string>(UserImage4);
  const [balance, setBalance] = useState<TBalance>({});
  const [qrCode, setQrCode] = useState<string>("");
  const {userData} =useContext<IAuthContextProps>(AuthContext)

  const [popup, setPopup] = useState<{
    isShow: boolean;
    type: "QRCode" | "messSuccess" | "messError";
  }>({
    isShow: false,
    type: "QRCode",
  });
  const location = useLocation();
  useEffect(() => {
    loadBalance();
  }, []);
  const loadBalance = () => {
    if (userData) {

      axios
        .get("/getBalance")
        .then((res) => {
          setBalance(res.data.result);
          localStorage.setItem("balance", res.data.result.balances);
        })
        .catch((err) => console.log(err));
    }
  };
  const showQR = () => {
    axios
      .get("/get-qr")
      .then((res) => {
        setQrCode(res.data.result);
        setPopup({ isShow: true, type: "QRCode" });
      })
      .catch((err) => console.log(err));
  };

  return (
    <Header>
      <HeaderLeft className="card-title h4 px-5">
        {iot.find((i) => i.path === location.pathname)?.id}
      </HeaderLeft>
      <HeaderRight>
        <div
          className="col d-flex align-items-center cursor-pointer"
          role="presentation"
        >
          {/*<Button*/}
          {/*  className="mx-4"*/}
          {/*  color="primary"*/}
          {/*  icon="AccountBalanceWallet"*/}
          {/*  onClick={() => showQR()}*/}
          {/*>*/}
          {/*  Nạp tiền Ví*/}
          {/*</Button>*/}
          <div className="me-3">
            <div className="text-end">
              <div className="fw-bold fs-5 mb-0">{userData.full_name}</div>
              <div className="fw-bold fs-5 ">
                <Button
                  onClick={() => loadBalance()}
                >
                  <Icon icon="Autorenew" size={'2x'}  color='primary'/>
                </Button>
                <small className="text-primary">
                  {Number(localStorage.getItem("balance")).toLocaleString() ||
                    0}{" "}
                  vnđ
                </small>
                , <small>{userData.agency_name}</small>
              </div>
            </div>
          </div>
          <div className="position-relative">
            <Avatar src={userData.avatar||''} size={48} />
          </div>
        </div>
      </HeaderRight>
      <Popup
        setType={(type: "QRCode" | "messSuccess" | "messError") =>
          setPopup({
            ...popup,
            type: type,
          })
        }
        type={popup.type}
        isOpen={popup.isShow}
        setIsOpen={(status: boolean) =>
          setPopup({
            ...popup,
            isShow: status,
          })
        }
        qrCode={qrCode}
      />
    </Header>
  );
};
export default BalancesHeader;
interface NewType {
  isOpen: boolean;
  setIsOpen: any;
  setType: any;
  type: "QRCode" | "messSuccess" | "messError";
  qrCode: string;
}

const Popup: FC<NewType> = ({ isOpen, setIsOpen, type, setType, qrCode }) => {
  type TBalance = {
    balances?: number; // 599003,
    agency?: string; // "Itel",
    name?: string; // "Nguyen van D"
  };

  const [load, setLoad] = useState<boolean>(false);

  const body = {
    QRCode: (
      <>
        <p
          style={{
            fontWeight: 500,
            fontSize: 30,
            color: "#000000",
            textAlign: "center",
          }}
        >
          {"Quét mã QRcode để nạp tiền Ví"}
        </p>

        <img
          src={qrCode}
          alt="QRCode"
          width={500}
          height={500}
          style={{ objectFit: "contain" }}
        />

        <Button
          className="btn btnCustom"
          icon="Autorenew"
          onClick={() => updateBalance()}
        >
          {"Cập nhật số dư Ví"}
        </Button>
      </>
    ),
    messSuccess: (
      <>
        <p className="lableMess">{"THÔNG BÁO"}</p>
        <p className="mess">
          Nạp tiền thành công
          <br />
          Ví của bạn đã được cập nhật số dư mới!
        </p>
      </>
    ),
    messError: (
      <>
        <p className="lableMess">{"THÔNG BÁO"}</p>
        <p className="mess">
          Cập nhật số dư Ví không thành công
          <br />
          Vui lòng kiểm tra lại sau ít phút!
        </p>
        <div className="d-flex mx-auto">
          <Button
            className="btn btnCustom mx-4"
            onClick={() => setIsOpen(false)}
          >
            {"Đóng"}
          </Button>
          <Button
            className="btn btnCustom"
            icon="Autorenew"
            onClick={() => updateBalance()}
          >
            {"Cập nhật lại"}
          </Button>
        </div>
      </>
    ),
  };

  const updateBalance = () => {
    setLoad(true);
    let balanceCuren = localStorage.getItem("balance") || 0;
    let count = 0;
    let Inter = setInterval(() => {
      axios
      .get("/getBalance")
      .then((res) => {
        let info: TBalance = res.data.result;
        if (info.balances && info.balances > balanceCuren) {
          localStorage.setItem("balance", info.balances.toString());
          setLoad(false);
          clearInterval(Inter);
        return setType("messSuccess");
      }
      return setType("messError");
    })
    .catch((err) => console.log(err));
      console.log(count)
      if (count >= 6) {
        setLoad(false)
        clearInterval(Inter);
      }
      count++;
    }, 5000);



  };

  if (load) return <Loading />;

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      isStaticBackdrop
      isScrollable
      isCentered
      size="lg" // 'sm' || 'lg' || 'xl'
      fullScreen="md" //sm' || 'md' || 'lg' || 'xl' || 'xxl'
      isAnimation
    >
      <ModalHeader
        children={undefined}
        setIsOpen={(status) => {
          setIsOpen(status);
        }}
      />
      <ModalBody>
        <div
          className="d-flex"
          style={{ flexDirection: "column", alignItems: "center" }}
        >
          {body[type || "QRCode"]}
        </div>
      </ModalBody>
    </Modal>
  );
};
